<!--
 * @Description: 商机变动情况
 * @Author: zz
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table :columns="columns" v-model:search="searchFrom" @fetch="fetch" tableId="lbuChanceModifies">
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="客户名称">
              <a-input v-model:value="searchFrom.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户代码">
              <a-input v-model:value="searchFrom.tmsCode" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="商机ID">
              <a-input v-model:value="searchFrom.chanceId" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="变动类型">
              <a-select v-model:value="searchFrom.changeType" placeholder="请选择" allowClear :options="chanceModifiesTypeEnum" />
            </dc-form-item>
            <dc-form-item name="createBy" label="操作人">
              <user-select v-model:value="searchFrom.createBy" />
            </dc-form-item>
            <dc-form-item name="createTime" label="操作时间">
              <cos-range-picker
                  v-model:startTime="searchFrom.createStartTime"
                  v-model:endTime="searchFrom.createEndTime"
              />
            </dc-form-item>
            <dc-form-item label="员工区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="searchFrom.employeeRegionList" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <ExportButton
              appId="cos_lbu"
              taskType="330"
              :search="searchFrom"
              v-permission="'lbu_chanceModifies_export_btn'"
          >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, text }">
          <template v-if="column.type === 'amount'">
            <p>{{ formatAmount(text)}}</p>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">

import { ref, computed } from 'vue'
import { ChanceModifiesParams } from '@/typings/api/yuntuSales'
import { chanceModifiesTypeEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { chanceModifies } from '@/api/yuntuSales/analysis'
import { formatAmount } from '@/utils/format'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'

const searchFrom = ref<ChanceModifiesParams>({})
const columns = computed(() => [
  {
    title: '商机ID',
    dataIndex: 'chanceId',
    fixed: 'left',
    width: 150
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '客户代码',
    dataIndex: 'tmsCode'
  },
  {
    title: '操作人',
    dataIndex: 'createBy'
  },
  {
    title: '操作时间',
    dataIndex: 'createTime'
  },
  {
    title: '变动类型',
    dataIndex: 'changeType',
    dicData: chanceModifiesTypeEnum
  },
  {
    title: '变动前',
    dataIndex: 'beforeData',
    type: 'amount'
  },
  {
    title: '变动后',
    dataIndex: 'afterData',
    type: 'amount'
  }
])
const fetch = (params: ChanceModifiesParams, callBack: (res: any) => void) => {
  chanceModifies({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuChanceModifies' }
</script>

<style scoped></style>
